import React from "react";
import { useTranslation } from "@shared/utils/internationalization";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Icon from "@ui-kit/icons/Icon.web";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";

const CheckoutLabel = () => {
  const { t } = useTranslation("purchases");

  const { totalItemQuantity, isWaitlist } = usePublicBasket();

  return (
    <>
      <Flex
        fontWeight="bold"
        lineHeight="1em"
        borderRight={totalItemQuantity > 0 ? "1px solid white" : "none"}
        paddingRight={totalItemQuantity > 0 ? "10px" : "0px"}
      >
        {isWaitlist && totalItemQuantity > 0 ? (
          <span>{t("Join Waitlist")}</span>
        ) : (
          <span>{t("Checkout")}</span>
        )}
      </Flex>
      {totalItemQuantity > 0 && (
        <Flex alignItems="center" paddingLeft="xs" fontWeight="bold">
          <Icon.Cart.Outline color="contrast" boxSize="element.md" mr="2xs" />
          <span>{totalItemQuantity}</span>
        </Flex>
      )}
    </>
  );
};

export default CheckoutLabel;
